export function currentProject(
  state = {
    tickets: [],
    project: {},
    currentTicket: false,
    data: {},
  },
  action
) {
  switch (action.type) {
    case 'GET_CURRENT_PROJECT_START':
      return {
        ...state,
        tickets: [],
        project: {},
      };
    case 'GET_CURRENT_PROJECT_DONE':
      return {
        ...state,
        tickets: action.tickets,
        project: action.currentProject,
        data: action.slipAnalytics,
      };

    case 'DELETE_TICKET_START':
      return { ...state, data: {} };

    case 'DELETE_TICKET_DONE':
      return {
        ...state,
        data: action.data.slipAnalytics,
        tickets: state.tickets.filter(element => {
          if (element.ticketId !== action.deletedTicket) {
            return element;
          }
        }),
      };

    case 'CREATE_TICKET_START':
      return {
        ...state,
        tickets: [],
      };

    case 'CREATE_TICKET_DONE':
      return {
        ...state,
        tickets: [...state.tickets, action.createdTicket],
      };

    case 'CREATE_DRAFT_TICKET_START':
      return {
        ...state,
        tickets: [],
      };

    case 'CREATE_DRAFT_TICKET_DONE':
      return {
        ...state,
        tickets: [...state.tickets, action.createdTicket],
      };
    case 'GET_CURRENT_TICKET_START':
      return {
        ...state,
        currentTicket: false,
      };

    case 'GET_CURRENT_TICKET_DONE':
      return {
        ...state,
        currentTicket: action.currentTicket,
      };
    case 'EDIT_TICKET_START':
      return state;

    case 'EDIT_TICKET_DONE':
      return state;
    case 'FAVORITE_TICKET_START':
      return state;

    case 'FAVORITE_TICKET_DONE':
      const tickets = state.tickets.map(ticket => {
        if (ticket.ticketId === action.ticketId) {
          ticket.favorite = !ticket.favorite;
        }
        return ticket;
      });
      if (state.currentTicket.ticketId === parseInt(action.ticketId)) {
        let currentTicket = state.currentTicket;
        currentTicket.favorite = !currentTicket.favorite;
        return {
          ...state,
          currentTicket,
          tickets: tickets,
        };
      } else {
        return {
          ...state,
          tickets: tickets,
        };
      }

    default:
      return state;
  }
}
